<mat-dialog-content>
  <lemon-dialog-header> Lisää tilitapahtuma manuaalisesti </lemon-dialog-header>

  <div class="dialog-form-container">
    <form>
      <div class="light-blue-text section-header">Perustiedot</div>

      <mat-form-field class="full-width-field">
        <mat-label>Päivämäärä</mat-label>
        <input matInput [matDatepicker]="picker" [formField]="lomake.pvm" autocomplete="off" data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        @if (onkoVirhe(lomake.pvm, 'required')) {
          <mat-error> Päivämäärä on pakollinen </mat-error>
        }
      </mat-form-field>

      <mat-form-field class="full-width-field">
        <mat-label>Summa</mat-label>
        <input decimalNumberField matInput [formField]="lomake.summa" [numberOfDecimals]="2" autocomplete="off" data-lpignore="true" />
        @if (onkoVirhe(lomake.summa, 'required')) {
          <mat-error> Summa on pakollinen </mat-error>
        }
      </mat-form-field>

      <span class="dark-gray-text" style="display: block; margin: 8px 0">Tilitapahtuman luominen vaatii validin IBAN tilinumeron, joka löytyy maksutavoista.</span>
      <mat-form-field class="full-width-field">
        <mat-label>Maksutapa (IBAN)</mat-label>
        <mat-select [formField]="lomake.maksutapa">
          @for (mt of kaikkiMaksutavat; track mt) {
            <mat-option [value]="mt"> {{ mt.nimi }} ({{ mt.sahkoisenTiliotteenTunniste }}) </mat-option>
          }
        </mat-select>
        @if (onkoVirhe(lomake.maksutapa, 'required')) {
          <mat-error> Maksutapa on pakollinen </mat-error>
        }
      </mat-form-field>

      <mat-form-field class="full-width-field">
        <mat-label>Valuutta</mat-label>
        <input type="text" matInput [formField]="lomake.valuutta" autocomplete="off" data-lpignore="true" />
        <mat-hint>Kolmikirjaiminen valuuttakoodi (esim. EUR)</mat-hint>
      </mat-form-field>

      <mat-form-field class="full-width-field">
        <mat-label>Kanava</mat-label>
        <mat-select [formField]="lomake.kanava">
          @for (option of tilitapahtumanKanavaOptions; track option) {
            <mat-option [value]="option.value"> {{ option.label }} ({{ option.value }}) </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="full-width-field">
        <mat-label>Tila</mat-label>
        <mat-select [formField]="lomake.tila">
          @for (option of tilitapahtumanTilaOptions; track option) {
            <mat-option [value]="option.value"> {{ option.label }} ({{ option.value }}) </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div class="light-blue-text section-header-with-spacing">Lisätiedot (valinnainen)</div>

      <mat-form-field class="full-width-field">
        <mat-label>Viite</mat-label>
        <input type="text" matInput [formField]="lomake.viite" autocomplete="off" data-lpignore="true" />
      </mat-form-field>

      <mat-form-field class="full-width-field">
        <mat-label>Maksaja</mat-label>
        <input type="text" matInput [formField]="lomake.maksaja" autocomplete="off" data-lpignore="true" />
      </mat-form-field>

      <mat-form-field class="full-width-field">
        <mat-label>Maksajan IBAN</mat-label>
        <input type="text" matInput [formField]="lomake.maksajanIban" autocomplete="off" data-lpignore="true" />
      </mat-form-field>

      <mat-form-field class="full-width-field">
        <mat-label>Viesti</mat-label>
        <input type="text" matInput [formField]="lomake.viesti" autocomplete="off" data-lpignore="true" />
      </mat-form-field>

      <mat-form-field class="full-width-field">
        <mat-label>Lisätiedot</mat-label>
        <textarea matInput [formField]="lomake.lisatiedot" rows="2" autocomplete="off" data-lpignore="true"></textarea>
      </mat-form-field>

      <mat-form-field class="full-width-field">
        <mat-label>Nippu ID</mat-label>
        <input type="text" matInput [formField]="lomake.nippuId" autocomplete="off" data-lpignore="true" />
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <app-secondary-button mat-dialog-close actionId="Peruuta tilitapahtuman lisäys"> Peruuta </app-secondary-button>
  <app-primary-button (click)="luoTilitapahtuma()" actionId="Lisää tilitapahtuma"> Lisää tilitapahtuma </app-primary-button>
</mat-dialog-actions>
